module.exports = __webpack_public_path__ + "img/auth-sm.de5b622c.png";